/**
 * Access control constants — frontend ESM copy of `lib/constants/access.js`.
 *
 * Duplicated (not re-exported) because no other module under views/react/
 * imports from lib/, so the webpack/babel CJS→ESM interop path is
 * unvalidated for that direction. A mocha-integration parity test
 * (test/integration/constants-parity.test.js) guarantees the two files
 * stay in sync.
 */
export const ACCESS_MODES = Object.freeze({
    OWNED: 'owned',
    PUBLIC_OF_OTHER: 'public-of-other',
})

export const ACCESS_DENIED_REASONS = Object.freeze({
    REQUIRES_LOGIN: 'requires-login',
    FORBIDDEN: 'forbidden',
    NOT_FOUND: 'not-found',
    UNAVAILABLE: 'unavailable',
})
